import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import toast from "react-hot-toast";
import { privateApi } from "../../api";

const CategoryManage = () => {
      const [loading, setLoading] = useState(false);
      const [categories, setCategories] = useState([]);
      const [limit, setLimit] = useState(10000);
      const [orders, setOrders] = useState([]);

      const loadData = async () => {
            setLoading(true);
            await privateApi
                  .get(`/dashboard/categories?limit=${limit}`)
                  .then((response) => {
                        setCategories(response.data.categories);
                        setLoading(false);
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };
      useEffect(() => {
            loadData();
      }, [limit]);

      const handleDragStart = (e, index) => {
            e.dataTransfer.setData("index", index.toString());
      };

      const handleDragOver = async (e, order) => {
            e.preventDefault();
            setOrders(order);
      };

      const handleDrop = async (e, dropIndex) => {
            const dragIndex = parseInt(e.dataTransfer.getData("index"));
            const draggedProduct = categories[dragIndex];

            const updatedProducts = categories.filter(
                  (item, index) => index !== dragIndex
            );

            updatedProducts.splice(dropIndex, 0, draggedProduct);

            setCategories(updatedProducts);

            await privateApi
                  .post(`/dashboard/categories/orders/change`, {
                        categories: updatedProducts,
                  })
                  .then((response) => {
                        console.log(response.data);
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      return (
            <>
                  <div>
                        {!loading ? (
                              categories?.map((item, index) => (
                                    <>
                                          <div
                                                className="draggable-row draggable-item"
                                                key={index}
                                                draggable="true"
                                                onDragStart={(e) =>
                                                      handleDragStart(e, index)
                                                }
                                                onDragOver={(e) =>
                                                      handleDragOver(
                                                            e,
                                                            categories
                                                      )
                                                }
                                                onDrop={(e) =>
                                                      handleDrop(e, index)
                                                }
                                          >
                                                <div>
                                                      <div
                                                            dangerouslySetInnerHTML={{
                                                                  __html: item?.icon,
                                                            }}
                                                            className="category__icon"
                                                      ></div>
                                                </div>
                                                <div className="text-start">
                                                      <div>{item.title}</div>
                                                      <div className="text-muted">
                                                            {`${
                                                                  item.sub_category
                                                                        ? "Sub Category:" +
                                                                          item.sub_category
                                                                        : ""
                                                            } ${
                                                                  item?.parent_category
                                                                        ? "Parent Category:" +
                                                                          item?.parent_category
                                                                        : ""
                                                            }`}
                                                      </div>
                                                </div>
                                          </div>
                                    </>
                              ))
                        ) : (
                              <Spinner />
                        )}
                  </div>
            </>
      );
};

export default CategoryManage;
